var _circle, _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ff5c39",
    cx: 16,
    cy: 16,
    r: 16
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 5,
    y1: 28,
    x2: 17,
    y2: 16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5c39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#485cc7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M7.174 12.066.006 16.266c.104 6.341 3.894 11.782 9.323 14.277L15.597 26.872V16.928L7.174 12.066z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.174 12.066 15.597 16.931v9.941l14.33-18.764z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProca);
export default __webpack_public_path__ + "static/media/Proca.d54e64a05a445e73ff0932504b4ab58f.svg";
export { ForwardRef as ReactComponent };